import { createFileRoute } from '@tanstack/react-router';
import { RfqNewPage } from '../../features/rfq';

export const Route = createFileRoute('/portal/rfq/new')({ component: RfqNewPage });
